import React, { useState, useEffect } from "react";
import dayjs from "dayjs";

import YearFilterDropdown from "ManagementTeam/Shared/YearFilterDropdown";
import MonthLink from "ManagementTeam/Shared/MonthLink";
import { BlobProvider } from "@react-pdf/renderer";
import AgendaPdf from "../AgendaPdf";
import AgendaDragDropContainer from "../AgendaDragDropContainer";
import AddNewModal from "ManagementTeam/Shared/AddNewModal";
import { useAuth } from "shared/@auth";
import { DragDropContext } from "react-beautiful-dnd";
import { useDocuments } from "ManagementTeam/DocumentsPage/useDocuments";

import styles from "./ArchivedAgendaPage.module.css";
import moment from "moment-timezone";
import { getNameOfTwoDaysMeeting } from "ManagementTeam/utils/meetingDateParse";
import { useAgenda } from "../useAgenda";
import MoveModal from "ManagementTeam/Shared/MoveModal";

export function ArchivedAgendaPage({
  selectedArchive,
  itemOwners,
  readOnly,
  meetingType,
  refetchArchive,
  isHideInfo,
}) {
  const { agendaItemPdfData, moveAgendaPut, duplicateAgendaPost } = useAgenda();
  const [showEditModal, setShowEditModal] = useState(false);
  const [editingItem, setEditingItem] = useState({});
  const [currentArchivedYear, setCurrentArchivedYear] = useState(null);
  const [displayedArchivedAgendas, setDisplayedArchivedAgendas] =
    useState(null);
  const [selectedArchivedAgenda, setSelectedArchivedAgenda] = useState(null);
  const [currentArchivedMeetingDate, setCurrentArchivedMeetingDate] =
    useState("");
  const [showMoveModal, setShowMoveModal] = useState(false);
  const [movingItem, setMovingItem] = useState({});

  const { account } = useAuth();
  const _ = require("lodash");
  const { downloadFile } = useDocuments();

  const [archivedYears, setArchivedYears] = useState([]);
  useEffect(() => {
    selectedArchive &&
      setArchivedYears(
        _.uniq(
          _.map(selectedArchive, function (meeting) {
            return parseInt(meeting.dates[0].startsOn.substring(0, 4));
          })
        )
      );
  }, [selectedArchive]);

  const [_selectedArchive, setSelectedArchive] = useState(null);

  useEffect(() => {
    selectedArchive &&
      setSelectedArchive(
        selectedArchive.sort(function compare(a, b) {
          var dateA = new Date(a.dates[0].startsOn);
          var dateB = new Date(b.dates[0].startsOn);
          return dateB - dateA;
        })
      );
  }, [selectedArchive]);

  useEffect(() => {
    archivedYears.length > 0 && setCurrentArchivedYear(archivedYears[0]);
  }, [archivedYears]);
  const formatedMeetingDate = (meeting) => {
    let dateString =
      meeting.dates.length > 0
        ? meeting.dates.map((date) =>
            moment.utc(date.startsOn).format("MMMM DD, YYYY")
          )
        : [];
    return dateString.length === 2
      ? getNameOfTwoDaysMeeting(dateString)
      : dateString[0];
  };
  //Handles selecting a month and displaying the archived agendas for that month
  const handleSelectArchivedAgenda = (meeting) => {
    var meetingDatesArray =
      meeting.dates.length > 0
        ? meeting.dates.map((date) =>
            moment.utc(date.startsOn).format("MMMM DD, YYYY")
          )
        : [];
    setCurrentArchivedMeetingDate({
      id: meeting._id,
      option: formatedMeetingDate(meeting),
      dates: meetingDatesArray,
    });
    setSelectedArchivedAgenda(meeting);
  };

  //useEffect for filtering the archived agendas based off year selected
  useEffect(() => {
    if (_selectedArchive) {
      const _displayedArchivedAgendas = _selectedArchive.filter(
        (meeting) =>
          parseInt(meeting.dates[0].startsOn.substring(0, 4)) ===
          currentArchivedYear
      );
      setDisplayedArchivedAgendas(_displayedArchivedAgendas);
    }
  }, [currentArchivedYear, _selectedArchive]);

  // const [organizedArchiveData, setOrganizedArchiveData] = useState(null);
  // useEffect(() => {
  //   if (displayedArchivedAgendas && displayedArchivedAgendas.length > 0) {
  //     var test = _.groupBy(displayedArchivedAgendas, function (meeting) {
  //       return meeting.dates[0].startsOn.substring(0, 7);
  //     });
  //     var ordered = {};
  //     Object.keys(test)
  //       .sort()
  //       .forEach((key) => (ordered[key] = test[key]));
  //     setOrganizedArchiveData(ordered);
  //   }
  // }, [displayedArchivedAgendas, _]);

  // console.log("orgdata", organizedArchiveData);

  const handleEdit = (data) => {
    if (data.files && data.files.length > 0) {
      Promise.all(
        data.files.map(async (file) => {
          return {
            type: file.type,
            src: file.src,
            data: await agendaItemPdfData(
              file.src.match(/agendas\/.*?$/g)[0].replace("agendas/", "")
            ).then(async (res) => {
              const blob = await res.blob();
              const url = window.URL.createObjectURL(blob);
              const response = await fetch(url);
              const res_1 = response.text();
              return res_1;
            }),
          };
        })
      ).then((result) => {
        const notes = data.notes.map((note) => {
          return {
            content: note.note,
            author: note.postedBy.name,
            date: note.submittedOn,
            postedBy: note.postedBy,
            location: note.location,
          };
        });
        const choices = data.decision.choices.map(
          (choice) => choice.description
        );
        const itemInfo = {
          id: data._id,
          meetingId: data.meeting,
          isDraft: data.isDraft,
          isActionItem: data.isActionItem,
          itemOwner: data.owner,
          title: data.title,
          description: data.description,
          notes: [...notes],
          addTo: ["Agenda", choices.length > 0 ? "Decisions (Voting)" : null],
          votingRequirements: [],
          allowMultiple: data.decision.maximumChoices > 1,
          maximumChoices: data.decision.maximumChoices,
          selections: [...choices],
          documents: result,
        };
        if (data.decision.isBlockA) {
          itemInfo.votingRequirements.push('"A Block" Vote');
        }
        if (data.decision.isBlockB) {
          itemInfo.votingRequirements.push('"B Block" Vote');
        }
        if (data.decision.isMultipleChoice) {
          itemInfo.votingRequirements.push("Multiple Choice");
        }
        setEditingItem(itemInfo);
        setShowEditModal(true);
      });
    } else {
      const notes = data.notes?.map((note) => {
        return {
          content: note.note,
          author: note.postedBy.name,
          date: note.submittedOn,
          postedBy: note.postedBy,
          location: note.location,
        };
      });
      const choices = data.decision.choices.map((choice) => choice.description);
      const itemInfo = {
        id: data._id,
        meetingId: data.meeting,
        isActionItem: data.isActionItem,
        isDraft: data.isDraft,
        itemOwner: data.owner,
        title: data.title,
        description: data.description,
        notes: notes ? [...notes] : [],
        addTo: ["Agenda", choices.length > 0 ? "Decisions (Voting)" : null],
        votingRequirements: [],
        allowMultiple: data.decision.maximumChoices > 1,
        maximumChoices: data.decision.maximumChoices,
        selections: [...choices],
        document: data.document,
        documents: [],
      };
      if (data.decision.isBlockA) {
        itemInfo.votingRequirements.push('"A Block" Vote');
      }
      if (data.decision.isBlockB) {
        itemInfo.votingRequirements.push('"B Block" Vote');
      }
      if (data.decision.isMultipleChoice) {
        itemInfo.votingRequirements.push("Multiple Choice");
      }
      setEditingItem(itemInfo);
      setShowEditModal(true);
    }
  };

  const [pdfAgendas, setPdfAgendas] = useState([]);
  // agenda pdf
  useEffect(() => {
    if (selectedArchivedAgenda) {
      selectedArchivedAgenda.agenda.map((i, index) => {
        if (i.id) {
          var yesVote = 0;
          var noVote = 0;
          setPdfAgendas((prev) => [
            ...prev,
            {
              assignee: i.owner.name,
              assignedType:
                i.owner.name.toUpperCase().includes("PAUL TSIKA") ||
                i.owner.name.includes("Attorneys")
                  ? "Attorney"
                  : i.owner.name.includes("WWG") ||
                    i.owner.name.includes("WWG Guest")
                  ? "WWG"
                  : "Diamond",
              title: i.title,
              pdfName:
                i.document && i.document.files && i.document.files.length > 0
                  ? `${i.document.files[0].name}.${i.document.files[0].type}`
                  : "",
              description: i.description,
              isNew: false,
              isCompleted: i.isComplete,
              hasChoices:
                i.decision &&
                i.decision.choices &&
                i.decision.choices.length > 0,
              votingStatus:
                i.decision.status === "on"
                  ? "Voting in Progress"
                  : i.decision.status === "off"
                  ? "Upcoming"
                  : i.decision.votingStatus,
            },
          ]);
          return index;
        }
      });
    }
  }, [selectedArchivedAgenda]);

  const handleDownloadPdf = (e) => {
    e.map(async (file) => {
      await downloadFile(file.downloadPath);
    });
  };

  const handleOpenMove = (data) => {
    setMovingItem(data);
    setShowMoveModal(true);
  };

  const handleMove = (destinatedMeeting) => {
    moveAgendaPut
      .mutateAsync({
        agendaId: movingItem._id,
        addToMeetingId: destinatedMeeting.id,
      })
      .then(() => {
        refetchArchive();
        let newSelectedAgenda = selectedArchivedAgenda;
        // Remove moved item from
        newSelectedAgenda.agenda = newSelectedAgenda.agenda.filter(
          (a) => a._id !== movingItem._id
        );
        setSelectedArchivedAgenda(newSelectedAgenda);
      });
    setShowMoveModal(false);
  };

  const handleDuplicate = (destinatedMeeting) => {
    duplicateAgendaPost
      .mutateAsync({
        agendaId: movingItem._id,
        addToMeetingId: destinatedMeeting.id,
      })
      .then(() => {
        refetchArchive();
      });
    setShowMoveModal(false);
  };

  return !selectedArchivedAgenda ? (
    _selectedArchive && _selectedArchive.length > 0 ? (
      <div className={styles.archivedAgendasContainer}>
        <span className={styles.yearFilterContainer}>
          <YearFilterDropdown
            currentYear={currentArchivedYear}
            yearOptions={archivedYears}
            onChangeYear={setCurrentArchivedYear}
          />
        </span>
        {displayedArchivedAgendas &&
          displayedArchivedAgendas.map((meeting) => (
            <span className={styles.monthLinkContainer} key={meeting._id}>
              <MonthLink
                content={formatedMeetingDate(meeting)}
                onClick={() => handleSelectArchivedAgenda(meeting)}
              />
            </span>
          ))}
        <span className={styles.monthLinkContainer} />
      </div>
    ) : (
      <div className={styles.noAgendas}>No Archived Agendas!</div>
    )
  ) : (
    <>
      {account && editingItem && showEditModal && (
        <AddNewModal
          isOpen={showEditModal}
          onClose={() => setShowEditModal(false)}
          meetingDates={/* meetingDates */ []}
          onSave={() => true}
          onSaveDraft={() => true}
          currentUser={account.name}
          itemInfo={editingItem}
          itemOwners={[]}
        />
      )}
      {showMoveModal && (
        <MoveModal
          isOpen={showMoveModal}
          onClose={() => {
            setShowMoveModal(false);
            refetchArchive();
          }}
          onMove={handleMove}
          onDuplicate={handleDuplicate}
        />
      )}
      <span className={styles.meetingDateHeader}>
        <div
          className={styles.pageHeader}
          onClick={() => {
            setSelectedArchivedAgenda(null);
            setPdfAgendas([]);
          }}
        >
          <span className={styles.backArrow} />
          ARCHIVED AGENDAS
        </div>
        <span className={styles.buttonContainer}>
          <BlobProvider
            document={
              <AgendaPdf
                currentMeetingDate={currentArchivedMeetingDate}
                date={currentArchivedMeetingDate.option}
                agendaItems={pdfAgendas}
                currentMeetingInfo={{}}
                futureMeetings={[]}
                isArchived={true}
                archivedMeeting={selectedArchivedAgenda}
                meetingType={meetingType}
              />
            }
            fileName={`${dayjs().format("MM_DD_YYYY")} Agenda`}
          >
            {({ blob, url, loading, error }) => (
              <div className={styles.saveButton}>
                {loading ? (
                  <div style={{ cursor: "progress" }}>
                    <span>Save Agenda as PDF</span>
                  </div>
                ) : (
                  <a href={url} target="_blank" rel="noreferrer">
                    <span>Save Agenda as PDF</span>
                  </a>
                )}
              </div>
            )}
          </BlobProvider>
        </span>
      </span>
      <span
        className={styles.archivedDate}
      >{`${currentArchivedMeetingDate.option} Agenda`}</span>
      {selectedArchivedAgenda &&
      selectedArchivedAgenda.agenda &&
      selectedArchivedAgenda.agenda.length > 0 ? (
        <DragDropContext onDragEnd={() => true}>
          <div style={{ padding: "0em 6em 1em 0.75em" }}>
            <AgendaDragDropContainer
              readOnly={readOnly}
              dropdownData={selectedArchivedAgenda.agenda}
              meetingDates={[]}
              onClickPdf={(e) => handleDownloadPdf(e)}
              onActionItem={() => true}
              onDelete={() => true}
              onEdit={handleEdit}
              onMove={handleOpenMove}
              isArchived={true}
              isHideInfo={isHideInfo}
            />
          </div>
        </DragDropContext>
      ) : (
        <div className={styles.error}>No Agendas to Display</div>
      )}
    </>
  );
}
